import { stringNormalize } from "./string-normalize";

export const isSubstringOf = ({
  sourceString,
  searchString,
}: {
  searchString: string;
  sourceString: string;
}): boolean => {
  return stringNormalize(sourceString).includes(stringNormalize(searchString));
};
